import { render, staticRenderFns } from "./RewardsCardReceiver.vue?vue&type=template&id=4fa5d181&scoped=true&"
import script from "./RewardsCardReceiver.vue?vue&type=script&lang=js&"
export * from "./RewardsCardReceiver.vue?vue&type=script&lang=js&"
import style0 from "./RewardsCardReceiver.vue?vue&type=style&index=0&id=4fa5d181&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5d181",
  null
  
)

export default component.exports